// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"5eb2da5c","429":"652858e7","453":"c54cdf1d","923":"e0ff430d"}[chunkId] + ".chunk.js";
};